import React, { Fragment, useCallback, useEffect, useState } from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  NoDataFound,
} from "../../../../components/table/tableComponent";
import DefaultButton from "../../../../components/buttons/defaultButton";
import TableSkeleton from "../../../../components/skeleton/tableSkeleton";
import { FiEdit2, FiPlus } from "react-icons/fi";
import { BsEye } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
import { getPaymentHistoryList } from "../../../../../services/workspace/history.service";
import toast from "react-hot-toast";

const PaymentHistoryTable = () => {
  const [loading, setLoading] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [fetchMore, setfetchMore] = useState(false);
  const [tableData, setTableData] = useState();
  const [totalData, setTotalData] = useState();
  const { limit } = useSelector((state) => state.global);

  const headers = [
    "Transction ID",
    "Payment Date",
    "Payment Mode",
    "Amount",
    "Status",
    "Action",
  ];

  const navigate = useNavigate();

  const handleViewClick = (item) => {
    navigate(`/configuration/manage-history/payment-view/${item?.uuid}`, {
      state: { item },
    });
  };

  const fetchData = useCallback(() => {
    if (currentPage == 0 || !fetchMore) {
      setLoading(true);
    }
    getPaymentHistoryList({ search: "", page: currentPage, limit })
      .then((response) => {
        setTableData((prevTableData) => {
          const combinedData =
            currentPage === 1
              ? [...response.data]
              : [...prevTableData, ...response.data];
          return combinedData;
        });
        setTotalData(response.total);
      })
      .catch((error) => {
        toast.error("Failed to fetch reminder data!");
        console.error("Error fetching data: ", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, limit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  //   const _actions = (item) => [
  //     {
  //       access: null,
  //       component: (
  //         <ActionButton
  //           access={null}
  //           component={
  //             <DefaultButton
  //               variant="default"
  //               icon={<BsEye />}
  //               tooltip={"View"}
  //               onClick={() => {
  //                 navigate(
  //                   `/configuration/manage-history/payment-view/${item?.uuid}`
  //                 );
  //               }}
  //             />
  //           }
  //           module={null}
  //           submodule={null}
  //         />
  //       ),
  //     },
  //   ];

  return (
    <div className="flex flex-col gap-2">
      <Fragment>
        <Table className="shadow-md">
          <TableHeader>
            <TableRow>
              {headers.map((header, index) => (
                <TableHead sticky key={index}>
                  {header}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? (
              <TableSkeleton colSpan={headers.length} />
            ) : (
              <>
                {tableData?.length > 0 ? (
                  tableData?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item?.razorpay_payment_id ? item?.razorpay_payment_id: "N/A" }</TableCell>
                      <TableCell>
                        {moment(item?.created_at).format(
                          "DD MMM YYYY, hh:mm A"
                        )}
                      </TableCell>
                      <TableCell>{item?.razorpay_payment_method}</TableCell>
                      <TableCell>{item?.total_amount}</TableCell>
                      <TableCell>
                        <TableCell>{item?.razorpay_payment_status}</TableCell>
                      </TableCell>
                      <TableCell sticky className={"flex items-center gap-2"}>
                        {/* <RenderActionButtons
                          empty
                          actions={_actions(item)} 
                          module={MODULES_LIST.CONFIGURATION}
                          submodule={
                            null
                          }
                        /> */}
                        <DefaultButton
                          variant="default"
                          icon={<BsEye />}
                          tooltip={"View"}
                          onClick={() => handleViewClick(item)}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <NoDataFound colSpan={headers.length} />
                  </TableRow>
                )}
              </>
            )}
          </TableBody>
        </Table>
      </Fragment>
    </div>
  );
};

export default PaymentHistoryTable;
